export default {
  referralFraction () {
    return 0.5 // maybe introduce vuex component with a pull from the server
  },
  currency () {
    return '$' // maybe introduce vuex component with a pull from the server
  }
}



// WEBPACK FOOTER //
// ./src/helpers/global-data.js